// @ts-nocheck
import { useMemo, useState } from 'react';
import { ownerApi } from './ownerApi';
import { useLoad } from './lib/useLoad';
import { label } from './lib/labels';
import { businessDisplayName, formatDateTime, formatRelative } from './lib/format';
import PageHeader from './ui/PageHeader';
import DataTable from './ui/DataTable';
import Drawer from './ui/Drawer';
import Toggle from './ui/Toggle';
import BusinessPicker from './ui/BusinessPicker';
import EmptyState from './ui/EmptyState';
import Alert from './ui/Alert';
import { ClipboardDocumentListIcon } from '@heroicons/react/24/outline';

function detailLines(row) {
  const lines = [
    ['What happened', label('auditAction', row.reason || row.action)],
    ['Business', businessDisplayName(row) || 'Unknown business'],
    ['When', row.created_at ? formatDateTime(row.created_at) : 'Time not recorded'],
  ];
  if (row.actor_email || row.actor || row.actor_user_id) {
    lines.push(['Who', row.actor_email || row.actor || row.actor_user_id]);
  }
  const detail = row.summary || row.message || (row.details && row.details.summary);
  if (detail) lines.push(['Detail', detail]);
  return lines;
}

export default function OwnerAudit() {
  const events = useLoad(() => ownerApi.audit().then((data) => data.events || []), []);
  const businesses = useLoad(() => ownerApi.subscribers().then((data) => data.subscribers || []), []);
  const [showTests, setShowTests] = useState(false);
  const [business, setBusiness] = useState('');
  const [selected, setSelected] = useState(null);
  const rows = useMemo(() => (events.data || []).filter((row) => {
    if (!showTests && String(row.reason || row.action || '').toLowerCase().includes('brain')) return false;
    if (business && String(row.tenant_id || '') !== business) return false;
    return true;
  }), [events.data, showTests, business]);
  return (
    <div className="space-y-6">
      <PageHeader
        title="Activity log"
        subtitle="Changes and actions in this portal, newest first."
        actions={<Toggle checked={showTests} onChange={setShowTests} label="Show AI tests" />}
      />
      <BusinessPicker businesses={businesses.data || []} value={business} onChange={setBusiness} />
      {events.status === 'error' ? <Alert title="We couldn't load activity." detail={events.error} /> : null}
      <DataTable
        loading={events.status === 'loading'}
        columns={[
          { key: 'when', label: 'When', render: (row) => (row.created_at ? <span title={formatDateTime(row.created_at)}>{formatRelative(row.created_at)}</span> : 'Time not recorded') },
          { key: 'what', label: 'What happened', render: (row) => label('auditAction', row.reason || row.action) },
          { key: 'business', label: 'Business', render: (row) => businessDisplayName(row) || 'Unknown business' },
        ]}
        rows={rows}
        onRowClick={(row) => setSelected(row)}
        getRowId={(row) => row.id || `${row.action}-${row.created_at}`}
        searchText={(row) => `${row.action} ${row.tenant_id} ${businessDisplayName(row)}`}
        empty={<EmptyState icon={<ClipboardDocumentListIcon className="h-6 w-6" />} title="No activity yet" text="Price changes and account actions will show up here." />}
      />
      {selected ? (
        <Drawer title={label('auditAction', selected.reason || selected.action)} onClose={() => setSelected(null)}>
          <dl className="space-y-3 text-sm">
            {detailLines(selected).map(([name, value]) => (
              <div key={name}>
                <dt className="text-slate-500">{name}</dt>
                <dd className="mt-1 text-slate-900">{value}</dd>
              </div>
            ))}
          </dl>
        </Drawer>
      ) : null}
    </div>
  );
}
